import { TableHeaderCell } from "./TableHeaderCell";
import { HeaderGroup } from "react-table";
import { TableProps } from "./types";

export type ITableHeader<T extends object> = {
  headerGroups: HeaderGroup<T>[];
  stickyHeader?: boolean;
} & Pick<TableProps<T>, "handleColumnSort" | "sort" | "erroredColumns">;

export const TableHeader = <T extends object>({
  headerGroups,
  handleColumnSort,
  sort,
  erroredColumns,
  stickyHeader = true,
}: ITableHeader<T>) => {
  // No z-index on purpose: being position:sticky already paints the header
  // above the (static) rows, while portaled overlays (modals, popovers,
  // dropdowns) rely on DOM order and would lose to any positive z-index.
  return (
    <div
      className={stickyHeader ? "sticky top-0" : undefined}
      style={
        stickyHeader
          ? { backgroundColor: "var(--backgroundColor)" }
          : undefined
      }
    >
      {headerGroups.map((headerGroup, index) => (
        <div {...headerGroup.getHeaderGroupProps()} key={index}>
          {headerGroup.headers.map((column) => (
            <TableHeaderCell
              column={column}
              key={column.id}
              sort={sort}
              handleColumnSort={handleColumnSort}
              erroredColumns={erroredColumns}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
